import { all, call, put, takeLatest } from 'redux-saga/effects';
import { api } from 'services';
import { history } from 'store';
import {
  LOADING,
  ASYNC_CREATE_COMPANY,
  ASYNC_EDIT_COMPANY,
  ASYNC_DELETE_COMPANY,
  ASYNC_RESTORE_COMPANY,
  ASYNC_CREATE_COMPANY_RULE,
  ASYNC_EDIT_COMPANY_RULE,
  ASYNC_DELETE_COMPANY_RULE
} from 'store';

function* createCompany(action) {
  yield put({ type: LOADING, payload: true });

  try {
    yield call(api.post, 'companies', action.payload, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    yield call(history.push, '/companies');
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* editCompany(action) {
  yield put({ type: LOADING, payload: true });

  try {
    yield action.payload.append('_method', 'PUT');
    yield call(
      api.post,
      `companies/${action.payload.get('id')}`,
      action.payload,
      { headers: { 'X-Requested-With': 'XMLHttpRequest' } }
    );
    yield call(history.push, '/companies');
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* deleteCompany(action) {
  yield put({ type: LOADING, payload: true });

  try {
    yield call(api.delete, `companies/${action.payload.id}`);

    yield call(history.push, '/refresh');
    yield call(history.push, '/companies');
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* restoreCompany({ payload: { id } }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield call(api.get, `companies/restore/${id}`);

    yield call(history.push, '/refresh');
    yield call(history.push, '/companies/trash');
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* createCompanyRule({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield call(api.post, 'company-rules', payload);

    yield call(history.push, '/company-rules');
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* editCompanyRule({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield call(
      api.put,
      `company-rules/${payload.id}/${payload.fiscal_year}`,
      payload
    );

    yield call(history.push, '/company-rules');
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* deleteCompanyRule({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield call(api.delete, `company-rules/${payload.id}`);

    yield call(history.push, '/refresh');
    yield call(history.push, '/company-rules');
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

export default function* root() {
  yield all([
    takeLatest(ASYNC_CREATE_COMPANY, createCompany),
    takeLatest(ASYNC_EDIT_COMPANY, editCompany),
    takeLatest(ASYNC_DELETE_COMPANY, deleteCompany),
    takeLatest(ASYNC_RESTORE_COMPANY, restoreCompany),
    takeLatest(ASYNC_CREATE_COMPANY_RULE, createCompanyRule),
    takeLatest(ASYNC_EDIT_COMPANY_RULE, editCompanyRule),
    takeLatest(ASYNC_DELETE_COMPANY_RULE, deleteCompanyRule)
  ]);
}
